module.exports = __webpack_public_path__ + "static/media/secret-family-recipes.da9afd4f.png";